
var ServiceShowcase = (function () {
    const URL = './ASPWebDataServise.asmx/';
    let core = require('./core_last.js'),
        G_usl = JSON.parse(sessionStorage.getItem('G_usl')),
        vidUslObj = JSON.parse(sessionStorage.getItem('Vid_Usl'));

    //To CORE!!!!
    var _fetchAsync = async (url, caption, body = null) => {
        let jb = {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        };

        if (body !== null) {
            let sendJSON = JSON.stringify(body);
            jb.body = "{inputsParam:'" + sendJSON + "'}";

        }
        const promise = await fetch(url + caption, jb);
        return await promise.json();
    };

    // заполнение sessionStorage обьектом видов услуг(чтобы каждый раз не запрашивать)
    var _setListVidUsl = response => {
        let resp = JSON.parse(response.d);

        sessionStorage.setItem('G_usl', JSON.stringify(resp[0].id));

        //resp.forEach((value) => {
        //    if (value.nkod.indexOf('циально-бытовые') > 0) {
        //        sessionStorage.setItem('G_usl', JSON.stringify(value.id));
        //    }
        //})

        sessionStorage.setItem('Vid_Usl', JSON.stringify(resp));
        _addMarkupToCategory();

        core.stoptLoadingAnimation();
        //sessionStorage.removeItem('Vid_Usl'); //TO DO: подумать где дропнуть, а может и вообще не дропать ???????????..........., хотя надо
    }

    //создание разметки под списки видов услуг
    // search параметр поиска если true то создается разметка для результата поиска если false для витрины
    var _addMarkupToCategory = (search = false) => {
        let txt = '',
            vidUslObj = JSON.parse(sessionStorage.getItem('Vid_Usl')),
            G_usl = JSON.parse(sessionStorage.getItem('G_usl'));

        vidUslObj.forEach((value, index) => {
            if (search) {
                txt += '<div class="p-2 row">';
                txt += _createMarkupToCategory(true, value.id, value.nkod);
                txt += '</div>';
            }
            else {
                ///Перечень услуг - сделать чтобы выводились красиво, в едином стиле.
                txt += '<div class="p-2 row">';
                txt += _createMarkupToCategory(true, value.id, value.nkod);
                txt += '</div>';

                //if (value.id == G_usl) {
                //    txt += '<div class="p-2 row">';
                //    txt += _createMarkupToCategory(true, value.id, value.nkod);
                //    txt += '</div>';
                //}
                //else {
                //    // все остальные
                //    var txtSm = '';
                //    if ((index - 1) % 3 == 0) {
                //        txtSm += '</div><div class="p-2 row">';
                //        txtSm += _createMarkupToCategory(false, value.id, value.nkod);
                //    }
                //    else
                //        txtSm += _createMarkupToCategory(false, value.id, value.nkod);
                //    txt += txtSm;
                //}
            }
        })

        $('.block_usl__container').html(txt);

        $('.setCollapseData').on('click', _setCollapseData);

        if (!search)
            _getListUslFromPreview();
    };

    // добавление блока разметки 
    var _createMarkupToCategory = (base_block, id, caption) => {
        let txt = '';
        if (base_block) {
            txt += '<div class="col-12">';
            txt += '<div class="card text-center block_usl_' + id + '_shadow">';
            txt += '    <div class="card-header"><h4 class="block_usl_' + id + '_header">' + caption + '</h4></div>';
            txt += '    <div class="card-block text-center">';
            txt += '        <div style="display: flex;flex-direction: column;flex-wrap: nowrap;" class="block_usl_' + id + '_container"></div>';
            txt += '        <div class="setCollapseData" id="collapse_usl_block block_usl_' + id + '_collapse" ><hr /><sup><span class="setCollapseData" id="block_usl_' + id + '_collapse_span">Cмотреть все услуги</span><t><span class="collapse_usl_block_span glyphicon glyphicon-chevron-down"></span></t></sup><hr /></div>';
            txt += '    </div> </div> </div>';
        }
        else {
            txt += '<div class="col-xs-12 col-lg-4">';
            txt += '    <div class="card text-center block_usl__shadow">';
            txt += '        <div class="card-header"> <h4 class="block_usl_' + id + '_header">' + caption + '</h4> </div>';
            txt += '            <div class="block_usl block_usl_' + id + '_container"></div>';
            txt += '            <div class="setCollapseData" id="collapse_usl_block_in block_usl_' + id + '_collapse" ><hr /><sup><span class="setCollapseData" id="block_usl_' + id + '_collapse_span">Cмотреть все услуги</span><t><span class="collapse_usl_block_in_span glyphicon glyphicon-chevron-down"></span></t></sup><hr /></div>';
            txt += '        </div> </div>';
        }

        return txt;
    }

    //// свернуть развернуть при просмотре 
    var _setCollapseData = e => {
        core.startLoadingAnimation();
        let inxblock = (e.currentTarget.id.split(' ').length > 1) ? e.currentTarget.id.slice(19).split('_')[2] : e.currentTarget.id.split('_')[2],
            header = $('.block_usl_' + inxblock + '_header').text();
        $('.block_usl__container').html('');

        var txt = '<div class="p-2 row">';
        txt += _createMarkupToCategory(true, inxblock, header);
        txt += '</div>';
        $('.block_usl__container').html(txt);

        let promise = _fetchAsync(URL, 'GetListUslFromVidUsl', { s_uslId: inxblock }).then(response => _setListUslFromVidUsl(response), err => console.error(`ошибка при получении данных: ${err}`));

        $('.setCollapseData').on('click', _setBaseVidUsl);
        $('#block_usl_' + inxblock + '_collapse_span').text('вернуться к витрине');
        $('body,html').animate({
            scrollTop: 0
        }, 400);
    }

    //вернуться к начальному виду
    var _setBaseVidUsl = e => {
        $('body,html').animate({
            scrollTop: 0
        }, 400);
        $('.block_usl__container').html('');
        _addMarkupToCategory();
    }

    //запрос на заполнение данных для начального отображения 
    var _getListUslFromPreview = () => {
        const Q_ROW_BASE = 9, Q_ROW = 3;
        let vidUslObj = JSON.parse(sessionStorage.getItem('Vid_Usl'));

        vidUslObj.forEach((value) => {
            let sendObj = Object.create(null);
            if (value.id == G_usl)
                sendObj.qRow = Q_ROW_BASE; // основной большой блок
            else
                sendObj.qRow = Q_ROW; // все остальные

            sendObj.s_uslId = value.id;
            let promise = _fetchAsync(URL, 'GetListUslFromVidUsl', sendObj).then(response => _setListUslFromVidUsl(response), err => console.error(`ошибка при получении данных: ${err}`));
        })
    }

    var _setListUslFromVidUsl = response => {
        let resp = JSON.parse(response.d),
            info = null,
            description = null;

        if (Array.isArray(resp)) {
            resp.forEach((value) => {
                info = value.info;
                description = value.description;
            })
        }
        else {
            info = resp.info;
            description = resp.description;
        }
        _setListUslFromVidUslSngl(G_usl, info, description);

        core.stoptLoadingAnimation();
    }

    var _setListUslFromVidUslSngl = (G_usl, info, description) => {
        let txt = '',
            // костыль для определения сколько услуг отображать в блок 
            length_ = description.split('_').length,
            descr = description.split('_')[0],
            descrSearch = description.split('_')[1];

        if (length_ > 1 && descrSearch == 0) {
            // если поиск
            if (info != undefined)
                info.forEach((value, index) => {
                    txt += '<a class="base_link" href="./usluga_last.html?uslId=' + value.id + '"><p class="mb-0" style="text-indent:0px; padding:.25rem"> <span class="glyphicon glyphicon-triangle-right" aria-hidden="true" style="color:#004c8f"></span>' + value.nkod + '</p></a>'
                })
            else
                $('.block_usl_' + descr + '_shadow').hide();
        }
        else
            if (length_ > 1) {
                // если для витрины
                if (G_usl == descr) {
                    info.forEach((value, index, info) => {
                            txt += '<a class="base_link" href="./usluga_last.html?uslId=' + value.id + '"><p class="mb-0" style="text-indent:0px; padding:.25rem"> <span class="glyphicon glyphicon-triangle-right" aria-hidden="true" style="color:#004c8f"></span>' + value.nkod + '</p></a>';
                    })
                    txt += '</div>'
                }
                else {
                    txt += '<div style=" display: flex; flex-direction: column; justify-content: space-evenly; ">'
                    info.forEach((value, index, info) => {
                        txt += '<a class="base_link" href="./usluga_last.html?uslId=' + value.id + '"><p class="mb-0" style="text-indent:0px; padding:.25rem"> <span class="glyphicon glyphicon-triangle-right" aria-hidden="true" style="color:#004c8f"></span>' + value.nkod + '</p></a>';
                    })
                    txt += '<div/>'
                }


            }
            else {
                // если при раскратии
                if (info != undefined) {
                    txt += '<div style="display: flex; flex-wrap: nowrap; flex-direction: column;">'
                    info.forEach((value, index) => {
                        txt += '<a class="base_link" href="./usluga_last.html?uslId=' + value.id + '"><p class="mb-0" style="text-indent:0px; padding:.25rem"> <span class="glyphicon glyphicon-triangle-right" aria-hidden="true" style="color:#004c8f"></span>' + value.nkod + '</p></a>';
                        $('.block_usl_' + descr + '_shadow').show();
                    })
                    txt += '<div/>'
                }

            }

        $('.block_usl_' + descr + '_container').html(txt);
    }

    // устанавливает параметры с формы
    var _setSearchParameter = () => {
        const CAPTION_FORM = 'collapse_search_panel__form';

        let searchArr = $(`#${CAPTION_FORM}`).serializeArray(),
            searchObj = {},
            searchKey = [];

        searchArr.forEach((item) => {
            if (!searchKey.includes(item.name) && item.value != '')
                searchKey.push(item.name)
        });

        searchKey.forEach((item) => {
            let A = searchArr.filter(x => x.name === item);

            if (A.length > 1) {
                let arrTmp = A.map(a => a.value);
                searchObj[item] = arrTmp;
            }
            else {
                let val = A[0].value;
                searchObj[item] = val;
            }
        });

        return searchObj;
    };

    var _searchFunction = () => {
        let vidUslObj = JSON.parse(sessionStorage.getItem('Vid_Usl')),
            data = _setSearchParameter();

        core.startLoadingAnimation();

        $('.block_usl__container').html('');
        _addMarkupToCategory(true);

        vidUslObj.forEach((value) => {
            //$('.block_usl_' + value.id + '_collapse').attr("onClick", "index.setToggleBlock(" + value.id + ")");
            $('#block_usl_' + value.id + '_collapse_span').text('Вернуться к витрине');
            //$('.collapse_usl_block_span').css('margin-left', '-2rem');
        })
        $('.setCollapseData').on('click', _setBaseVidUsl);

        if (data.s_uslId) {
            vidUslObj.forEach((value) => {
                $('.block_usl_' + value.id + '_shadow').hide();
            })
            let promise = _fetchAsync(URL, 'GetListUslFromVidUsl', data).then(response => _setListUslFromVidUsl(response), err => console.error(`ошибка при получении данных: ${err}`));
        }
        else {
            vidUslObj.forEach((value, index, vidUslObj) => {
                let sendObj = {
                    s_uslId: value.id,
                    qRow: 0,
                    uslCaption: data.uslCaption,
                    form_obsl: data.form_obsl
                };
                let promise = _fetchAsync(URL, 'GetListUslFromVidUsl', sendObj).then(response => _setListUslFromVidUsl(response), err => console.error(`ошибка при получении данных: ${err}`));
            })
        }
    }

    var _clearFunction = () => {
        document.location.href = './index_last.html';
    }


    //-----------------------------------------
    var _setGroupОfАctivities = (resp, id) => {
        let response = JSON.parse(resp.d);

        if ($.isEmptyObject(response) || response.length == 0)
            return false;

        let listMerop = response;

        listMerop.forEach((value, index) => {
            let txt = '<a class="base_link"><p class="mb-0" style="text-indent:0px; padding:.25rem"> <span class="glyphicon glyphicon-triangle-right" aria-hidden="true" style="color:#004c8f"></span>' + value.nkod + '</p></a>';
            $('.gac-block_' + id + '_container').append(txt);
        });
    }


    var _setListCaptionMerop = resp => {
        let response = JSON.parse(resp.d);

        if ($.isEmptyObject(response) || response.HasError || response.Result.length == 0)
            return false;

        let listCaption = response.Result;
        listCaption.forEach(value => {
            let id = value.Id,
                caption = value.Caption,
                kode = value.Kod,
                txt = '';
            txt += '<div class="p-2 row">';
            txt += '<div class="col-12">';
            txt += '<div class="card text-center gac-item_' + id + '_shadow">';
            txt += '    <div class="card-header"><h4 class="block_usl_' + id + '_header">' + caption + '</h4></div>';
            txt += '    <div class="card-block text-center">';
            txt += '        <div style=" display: flex; flex-direction: column; justify-content: space-evenly; " class="row gac-block_' + id + '_container"></div>';
            //txt += '        <div class="setCollapseData" id="collapse-gac-block gac-block-' + id + '-collapse" ><hr /><sup><span class="setCollapseData" id="block_usl_' + id + '_collapse_span">Cмотреть все услуги</span><t><span class="collapse_usl_block_span glyphicon glyphicon-chevron-down"></span></t></sup><hr /></div>';
            txt += '    </div> </div> </div>';
            txt += '</div>';
            $('.block_merop__container').append(txt);

            let promise = _fetchAsync(URL, 'GetGroupОfАctivities', { kod: kode })
                .then(response => _setGroupОfАctivities(response, id), err => console.error(`ошибка при получении данных: ${err}`));
        });
        core.stoptLoadingAnimation();

    }
    //-----------------------------------------


    // точка входа 
    var init = () => {
        core.startLoadingAnimation();
        core.setControlforReestrListform() // рисуем контролы поиска

        if (vidUslObj == null)
            _fetchAsync(URL, 'GetListVidUsl', {}).then(response => _setListVidUsl(response), err => console.error(`ошибка при получении данных: ${err}`));
        else
            _addMarkupToCategory();

        const promise = _fetchAsync(URL, 'GetCaptionGroupОfАctivities', {})
            .then(response => _setListCaptionMerop(response), err => console.error(`ошибка при получении данных: ${err}`));
    };

    return {
        // public методы
        init: init,
        searchFunction: _searchFunction,
        clearFunction: _clearFunction,
    };
}());

(function main() {
    $("body").fadeIn(2000);

    $('#search--btn').on('click', ServiceShowcase.searchFunction);
    $('#clear--btn').on('click', ServiceShowcase.clearFunction);

    ServiceShowcase.init();
}());